<template>
  <footer>
    <div class="footer-top title langlist" langname="about">关于我们</div>
    <hr/>
    <div class="footer-text footer-small">
      <div class=" footer-center flex">
        <div class=" flex">
<!--          <div class=" flex">-->
<!--            <p class="title langlist" langname="about-us">关于我们</p>-->
<!--            <p><a class="service langlist" langname="terms-service">服务条款</a></p>-->
<!--            <p><a class="privacy langlist" langname="privacy-policy">隐私政策</a></p>-->
<!--          </div>-->
        </div>
        <div class="flex footer-img">
          <a href="https://twitter.com/DuckyVpn" target="_blank" class="flex">
            <img src="@/assets/images/twitter.png" alt="ducky-twitter">
            <span>Twitter</span>
          </a>
          <a href="https://www.facebook.com/profile.php?id=100070230468463" target="_blank" class="flex">
            <img src="@/assets/images/facebook.png" alt="ducky-facebook">
            <span>Facebook</span>
          </a>
          <a href="https://www.instagram.com/duckyvpn/" target="_blank" class="flex">
            <img src="@/assets/images/instagram.png" alt="ducky-instagram">
            <span>Instagram</span>
          </a>
        </div>

      </div>

      <div class=" footer-center flex">
        <div class="footer-text flex ">
          <p class="title langlist" langname="partners">合作</p>
          <p><a href="mailto:duckybd@outlook.com">duckybd@outlook.com</a></p>
        </div>
        <div class="footer-text flex">
          <p class="title langlist" langname="help-center">客服中心</p>
          <p><a :href="`mailto:${email}`" class="help-mail">{{email}}</a></p>
<!--          <p class="langlist tawkstar" langname="online-service">在线客服</p>-->
<!--          <p><a target="_blank" href="https://t.me/duckyvpn0">Telegram</a></p>-->
<!--          <p><a href="https://wa.me/qr/UIQRFMOTYP72E1" target="_blank">WhatsApp</a></p>-->
<!--          <p><a href="https://join.skype.com/invite/wPZt1qblg4pJ" target="_blank">Skype</a></p>-->
<!--          <p><a href="https://ptcc.in/chongyajiasu" target="_blank">Potato</a></p>-->
        </div>
      </div>
    </div>
    <div class="footer-text footer-center flex footer-bigger">
<!--      <div class="footer-text flex">-->
<!--        <p class="title langlist" langname="about-us">关于我们</p>-->
<!--        <p><a class="service langlist" langname="terms-service">服务条款</a></p>-->
<!--        <p><a class="privacy langlist" langname="privacy-policy">隐私政策</a></p>-->
<!--      </div>-->
      <div class="footer-text flex">
        <p class="title langlist" langname="partners">合作</p>
        <p><a href="mailto:duckybd@outlook.com">duckybd@outlook.com</a></p>
      </div>
      <div class="flex footer-img">
        <a href="https://twitter.com/DuckyVpn" target="_blank" class="flex">
          <img src="@/assets/images/twitter.png" alt="ducky-twitter">
          <span>Twitter</span>
        </a>
        <a href="https://www.facebook.com/profile.php?id=100070230468463" target="_blank" class="flex">
          <img src="@/assets/images/facebook.png" alt="ducky-facebook">
          <span>Facebook</span>
        </a>
        <a href="https://www.instagram.com/duckyvpn/" target="_blank" class="flex">
          <img src="@/assets/images/instagram.png" alt="ducky-instagram">
          <span>Instagram</span>
        </a>
      </div>
      <div class="footer-text flex">
        <p class="title langlist" langname="help-center">客服中心</p>
        <p><a :href="`mailto:${email}`" class="help-mail">{{email}}</a></p>
<!--        <p class="langlist tawkstar" langname="online-service">在线客服</p>-->
<!--        <p><a target="_blank" href="https://t.me/duckyvpn0">Telegram</a></p>-->
<!--        <p><a href="https://wa.me/qr/UIQRFMOTYP72E1" target="_blank">WhatsApp</a></p>-->
<!--        <p><a href="https://join.skype.com/invite/wPZt1qblg4pJ" target="_blank">Skype</a></p>-->
<!--        <p><a href="https://ptcc.in/chongyajiasu" target="_blank">Potato</a></p>-->
      </div>
    </div>
    <hr/>
    <div class="flex footer-bottom footer-text">
      <p class="langlist" langname="product">© {{new Date().getFullYear()}} {{appName}}</p>
      <p v-if="companyName" class="">{{companyName}} All Rights Reserved.</p>
      <p v-if="companyAddress" class="">{{companyAddress}}</p>
    </div>
  </footer>
</template>

<script setup>
  const props = defineProps(['companyName', 'companyAddress'])
</script>

<style scoped>

</style>
